import axios from '@/libs/api.request'
// for U分页
export const getMinisForUPage = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/tiktok/minis/for-u/page'
  })
}
// 编辑for U小程序
export const updateMinisForUUpdate = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/tiktok/minis/for-u/update'
  })
}
